




export default {
  name: 'MasterCardIcon'
}
